export default __webpack_public_path__ + "static/media/cloud.09a00724.svg";